import Header from "../Component/UserEnd/Header";
import AboutTitle from "../Component/UserEnd/AboutTitle";
import AboutStory from "../Component/UserEnd/AboutStory";
import AboutAchievements from "../Component/UserEnd/AboutAchievements";
import Footer from "../Component/UserEnd/Footer";
function About() {
  return (
    <>
      <Header />
      <AboutTitle />
      <AboutStory />
      <AboutAchievements />
      <Footer />
    </>
  );
}

export default About;
